import { ReactNode, forwardRef, useId } from "react";

import { cn } from "@intergamma/common/cn";

import * as CheckboxPrimitive from "@radix-ui/react-checkbox";

import { Description } from "./Description";
import { Error } from "./Error";
import { Checkbox } from "./Checkbox";

type CheckboxFieldProps = CheckboxPrimitive.CheckboxProps & {
  description?: ReactNode;
  error?: ReactNode;
  label: ReactNode;
};

export const CheckboxField = forwardRef<HTMLButtonElement, CheckboxFieldProps>(
  function CheckboxField(
    { className, description, error, label, disabled, ...props },
    ref,
  ) {
    const id = useId();

    return (
      <div className={cn("flex flex-col", className)}>
        <div
          className={cn(
            "relative flex w-full gap-2 text-100/6 gamma:text-functional-primary-800 karwei:text-brand-primary",
            disabled && "gamma:text-neutral-400 karwei:text-neutral-600",
          )}
        >
          <Checkbox ref={ref} id={id} disabled={disabled} {...props} />
          <label className={cn(!disabled && "cursor-pointer")} htmlFor={id}>
            {label}
          </label>
        </div>
        {error && <Error className="mt-1">{error}</Error>}
        {!error && description && (
          <Description className="mt-1">{description}</Description>
        )}
      </div>
    );
  },
);
